export default __webpack_public_path__ + "static/media/savedjobIcon.174f096e.svg";